<div>
    <label *ngIf="props.label" class="form-control-label">
        {{ props.label }}
        <span *ngIf="props.required">*</span>
    </label>
    <div class="d-flex">
        <div *ngFor="let option of props.optionsArray" class="form-group">
            <div class="form-check-inline cust-check">
                <label class="radio-container form-check-label" [for]="option.key">
                    <input type="radio" [value]="option.key"  [id]="option.key"
                        [formControlName]="props.field_Name" (change)="checkboxEmitter($event, option)"
                        [readonly]="props.readOnly"
                        [propreadonly]="props.readOnly" 
                        />
                    {{ option.label }}
                    <span class="checkmark"></span>
                </label>
            </div>
        </div>
    </div>
    <div class="error-container">
        <!-- <sm-error [control]="formcontrol"></sm-error> -->
        <sm-error [control]="formcontrol" [label]="props.label"></sm-error>

    </div>
</div>
